export default "__VITE_ASSET__BTjuG8G0__"